import React from "react";
import { PaymentElement } from "@stripe/react-stripe-js";

const StripePaymentElement = ({ onReady, onChange }) => (
  <PaymentElement onReady={onReady} onChange={onChange} />
);

export default StripePaymentElement;
